import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768; // Common breakpoint for mobile devices

export function useIsMobile(): boolean {
  // Initialize synchronously so the first render already reflects the real
  // viewport. Otherwise the hero picks the desktop background on mount and
  // only flips to mobile after the effect runs, undercutting the preload.
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    // Check on initial mount
    checkScreenSize();

    // Add resize listener
    window.addEventListener('resize', checkScreenSize);

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []); // Empty dependency array ensures this runs only on mount and unmount

  return isMobile;
}
